import AboutSection from "./AboutSection";

const About = () => {
  return (
    <AboutSection>
      <h2>About me</h2>

      <p>
        Hello! My name is Abhishek, and I’m a passionate developer from India
        with a strong interest in frontend and backend technologies, along with
        hands-on exposure to AWS. I primarily focus on frontend development
        while also building backend functionalities and leveraging cloud
        services to deliver scalable and reliable web applications.
      </p>

      <p>
        Currently, I’m working as a{" "}
        <span className="about-me-section-para-highlight">
          Frontend Developer at MobFountain Media
        </span>
        . In my full-time role, I develop dynamic, high-performance websites
        using modern frontend libraries and frameworks, while managing complex
        company data through CMS platforms to ensure scalability, reliability,
        and smooth content workflows.
      </p>

      <p>
        With around 2 years of experience, I consider myself at an early
        professional stage and a quick learner who actively explores new
        technologies, especially in cloud and modern web development. I
        regularly experiment with and implement new tools to understand their
        fundamentals and continuously strengthen my skill set.
      </p>

      <p>
        I enjoy learning and applying new technologies alongside my daily work.
        I stay curious about improving performance, code quality, and user
        experience, and I’m always eager to grow as a developer by exploring
        modern tools, frameworks, and best practices.
      </p>

      <p>
        <ul>
          <li>
            Strong experience in building responsive and interactive user
            interfaces using <span>JavaScript (ES6+)</span>,{" "}
            <span>React.js</span>, and <span>Next.js</span>.
          </li>
          <li>
            Experience developing backend functionalities using{" "}
            <span>Node.js</span> and <span>Express.js</span>, and working with
            REST APIs.
          </li>
          <li>
            Hands-on experience managing and integrating data using{" "}
            <span>CMS platforms</span> for large-scale content-driven
            applications.
          </li>
          <li>
            Working knowledge of cloud services with <span>AWS (basic)</span>,
            including deployment and application hosting concepts.
          </li>
          <li>
            Familiar with <span>GitHub Actions</span> and basic{" "}
            <span>CI/CD</span> workflows.
          </li>
          <li>
            Basic experience with <span>Docker</span> for containerized
            development environments.
          </li>
          <li>
            Comfortable working in <span>Mac</span>/<span>Linux</span>
            environments and using <span>Git</span> for version control.
          </li>
          <li>
            Actively improving skills in modern frontend architecture,
            performance optimization, and scalable UI development.
          </li>
        </ul>
      </p>
    </AboutSection>
  );
};

export default About;
